import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { monthAndYear } from '../../../../../../../../../shared/utils/formattedDates';


import PriceDisplay from './components/PriceDisplay';
import DpeDisplay from './components/DpeDisplay';
import { Slider } from 'hosman-material';
import { S_LocationDot, D_HouseBuilding, S_UpRightAndDownLeftFromCenter , D_Puzzle, D_CircleSort, D_CalendarDays, D_User, D_Gear } from 'hosman-material';

const FullInfos = ({ property, setProperty }) => {
  const { elevator, garden, parking, terrace, concierge, cellar, pool  } = property
  const annexes = [{ name: 'Terrasse', value: terrace }, { name: 'Ascenseur', value: elevator }, { name: 'Jardin', value: garden }, { name: 'Parking', value: parking }, { name: 'Piscine', value: pool }, { name: 'Concierge', value: concierge }, { name: 'Cave', value: cellar }]
  const filteredAnnexes = annexes.filter(annexe => annexe.value === true);
  const filteredAnnexesString = filteredAnnexes.map((annexe) => annexe.name).join(' / ');

  const displayFloor = () => {
    if (property.kind === 'house' || property.kind === 'parking') return;
    if (!property.floor || !property.total_floor) return;

    let displayedFloor = ''
    if (property.floor === 0) {
      displayedFloor = 'RDC'
    } else {
      displayedFloor = `${property.floor}/${property.total_floor}`
    }

    return displayedFloor
  }

  const translateSituation = (situation) => {
    switch (situation) {
      case 'primo_buyer':
        return 'Primo-accédent'
      case 'owner':
        return 'Secondo-accédant'
      case 'rental_investment':
        return 'Investisseur'
    }
  }

  const getRangeByDecade = (number) => {
    const lower = Math.floor(number / 10) * 10;
    const upper = lower + 10;
    return `entre ${lower} et ${upper} ans`;
  }

  if (!property.property_pictures) return null;

  return (
    <div className='overflow-hidden'>
      <Slider
        insideArrows
        items={property.property_pictures.map(picture => {
          return (
            <div className='w-72 xl:w-80'>
              <img key={picture.id} src={picture.photo_url} className='object-cover rounded-lg' />
            </div>
          )
        })}
      />

      <div className='grid grid-cols-1 xl:grid-cols-2 gap-6 p-5 text-sm'>
        <div className='flex flex-col gap-3'>
          <p className='h3'>Le bien</p>
          
          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={S_LocationDot} /></div>
            <p className='line-clamp-3 whitespace-pre-line'>Adresse : <span className='font-bold'>{property.address?.replace(/, /g, ',\n')}</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_HouseBuilding} /></div>
            <p>Type de bien : <span className='font-bold'>{property.kind_text}</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={S_UpRightAndDownLeftFromCenter} /></div>
            <p>Surface : <span className='font-bold'>{property.area} m²</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_Puzzle} /></div>
            <p>Nombre de pièces : <span className='font-bold'>{property.room_number}</span></p>
          </div>

          {displayFloor() &&
            <div className='flex items-center gap-2'>
              <div className='w-4'><FontAwesomeIcon icon={D_CircleSort} /></div>
              <p>Etage : <span className='font-bold'>{displayFloor()}</span></p>
            </div>
          }

          {filteredAnnexesString &&
            <div className='flex items-center gap-2'>
              <div className='w-4'><FontAwesomeIcon icon={D_Gear} /></div>
              <p>Prestations : <span className='font-bold'>{filteredAnnexesString}</span></p>
            </div>
          }

          <DpeDisplay property={property} />
        </div>

        <div className='flex flex-col gap-3'>
          <p className='h3'>La vente</p>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_CalendarDays} /></div>
            <p>Date de la vente : <span className='font-bold'>{monthAndYear(property.oa_date)}</span></p>
          </div>

          <div className='flex items-center gap-2'>
            <div className='w-4'><FontAwesomeIcon icon={D_User} /></div>
            <p>Profil acquéreur : <span className='font-bold'>{translateSituation(property.buyer_situation) || 'Acheteur'} {property.buyer_age && getRangeByDecade(property.buyer_age)}</span></p>
          </div>
          
          <PriceDisplay property={property} setProperty={setProperty} />
        </div>
      </div>
    </div>
  );
};

export default FullInfos;
